export default {"src":"/_next/static/media/0x322e86852e492a7ee17f28a78c663da38fb33bfb.668df216.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};